import { useQueryClient, useQuery } from "react-query";
import { simpleRequest } from "core/services/api";
import { loginBodySchema } from "../schemas/loginSchemas";
import { OktaOidcCredentialsFormSchema } from "../schemas/oktaOidcCredentialsFormSchema";
import { methodSchema } from "core/schemas/http";
import { ENDPOINTS } from "modules/shared/webservices/constants/endpoints";
import useTokenStore from "./useTokenStore";

export const oktaOidcLogin = (
  temCodeCredentials: OktaOidcCredentialsFormSchema
) =>
  simpleRequest(
    ENDPOINTS.LOGIN_OIDC,
    loginBodySchema,
    methodSchema.enum.post,
    temCodeCredentials,
    false
  );

export const useOktaOidcLogin = (payload: OktaOidcCredentialsFormSchema) => {
  const queryClient = useQueryClient();
  queryClient.invalidateQueries(["selfcare"]);
  const setToken = useTokenStore(({ setToken }) => setToken);
  return useQuery(["oktaLoginOidc"], () => oktaOidcLogin(payload), {
    onSuccess: (data) => {
      setToken(data.token);
      queryClient.invalidateQueries(["selfcare"]);
    },
  });
};
